module.exports = __webpack_public_path__ + "img/marcha-sate.f438be22.jpg";